import { BIGRAM_REGEXP } from './constants';

export default function isBigramInUrl(url: string) {
  const tokens = url.split('/').filter(Boolean);

  return tokens.some(token => BIGRAM_REGEXP.test(token));
}
